export default __webpack_public_path__ + "static/media/bg-valdano-bio-01.d4f0875f.jpg";